import React from "react";

const Logo = (props) => {
  return (
    <img
      src="/images/logo/Logo New with Name-ENG_final.png"
      width={"100%"}
      alt="Logo"
      {...props}
    />
  );
};

export default Logo;
